import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { ASSISTANTS_QUERY_KEY, useAssistantApi } from "./useAssistantApi";

export const useAssistantsQuery = () => {
  const { getAssistants } = useAssistantApi();

  return useQuery({ queryKey: ASSISTANTS_QUERY_KEY, queryFn: getAssistants });
};

export const useAssistantQuery = (assistantId: string) => {
  const { getAssistant } = useAssistantApi();

  return useQuery({
    queryKey: [...ASSISTANTS_QUERY_KEY, assistantId],
    queryFn: () => getAssistant(assistantId),
    enabled: !!assistantId,
    retry: false,
  });
};

export const useReloadAssistant = (
  assistantId: string,
): (() => Promise<void>) => {
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: [...ASSISTANTS_QUERY_KEY, assistantId],
      }),
    [queryClient, assistantId],
  );
};

export const useReloadAssistants = (): (() => Promise<void>) => {
  const queryClient = useQueryClient();

  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: ASSISTANTS_QUERY_KEY }),
    [queryClient],
  );
};
